import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getListHistoriesByBarcodeV2 } from "../../../services/api/apiItemHistory"
import timeHumanize from "../../helpers/timeHumanize"
import ObjectInspector from 'react-inspector'
import { Pagination, Select, Tooltip, Popover } from 'antd'


class ItemHistories extends Component {
    state = {
        histories: [],
        loading: false,
        error: '',
        limit: 200,
        page: 1,
        total: 0,
        filter: {
            exclude_event_key: ['capture_commitment_time']
        }
    }

    componentDidMount() {
        this._fetchHistories()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { item } = this.props

        if (item && prevProps && prevProps.item && item.productId !== prevProps.item.productId) {
            return this._fetchHistories()
        }
    }

    _fetchHistories = async () => {
        if (this.state.loading) return true

        this.setState({
            loading: true,
            error: ''
        })
        const { limit, page, filter = {} } = this.state
        const { exclude_event_key = [] } = filter || {}
        const barcode = this._getBarcode()
        try {
            const payload = {
                limit: limit,
                page: page,
            }
            if (exclude_event_key.length > 0) payload.query = {
                exclude_event_key: exclude_event_key
            }

            const { success, data, message } = await getListHistoriesByBarcodeV2(barcode, payload)

            if (!success) {
                throw new Error(message)
            }

            return this.setState({
                histories: Array.isArray(data.histories) ? data.histories : [],
                loading: false,
                error: '',
                page: page,
                total: data.total,
            })
        } catch (e) {
            return this.setState({
                error: e.message,
                loading: false,
            })
        }
    }

    _getBarcode = () => {
        const { item } = this.props
        const { barcodeNumber, product } = item
        const { pos: item_index } = product

        return `${barcodeNumber}_${item_index}`
    }

    _handlePageChange = (page, pageSize) => {
        this.setState({
            page: page,
            limit: pageSize,
        }, () => {
            this._fetchHistories();
        });
    }

    handleChangeSelect = (value) => {
        const { filter = {} } = this.state
        this.setState({
            filter: { ...filter, exclude_event_key: value || [] },
            page: 1
        }, () => {
            this._fetchHistories()
        })
    }

    render() {
        const { histories, limit, page, total, filter } = this.state
        const { exclude_event_key = [] } = filter || {}
        const excludeOptions = [
            { label: 'capture_commitment_time', value: 'capture_commitment_time' }
        ]

        return (
            <div className="ItemHistories">
                <div className="d-flex align-items-center justify-content-between">
                    <h3 className='mr-4'>Item histories</h3>
                    <div className="filters d-flex align-items-center">
                        <div className="exclude d-flex align-items-center">
                            <Tooltip title='Loại trừ key' placement={'rightTop'}>
                                <Select
                                    placeholder='Loại trừ key'
                                    value={exclude_event_key || []}
                                    onChange={this.handleChangeSelect}
                                    showSearch
                                    allowClear
                                    mode={'tags'}
                                    options={excludeOptions}
                                />
                            </Tooltip>
                        </div>
                    </div>
                </div>

                <table className="table">
                    <thead>
                        <tr>
                            <th className="colID">#</th>
                            <th className="colTime">Time</th>
                            <th className="colDescription">Description</th>
                            <th className="colUser">Người tạo</th>
                            <th className="colIP">IP</th>
                            <th className="colMeta">Key</th>
                            <th className="colNote">Lý do</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            histories.map((history, index) => {
                                const { _id, event_key, event_description, event_meta, created, user_created, note } = history
                                const ip = event_meta !== undefined ? (event_meta.IP || '--') : '--'

                                if (event_meta !== undefined && event_meta.IP !== undefined) delete event_meta['IP']

                                return (
                                    <tr key={_id}>
                                        <td className="colID">{index + 1}</td>
                                        <td className="colTime">{timeHumanize(created)}</td>
                                        <td className="colDescription">{event_description}</td>
                                        <td className="colUser">{user_created}</td>
                                        <td className="colIP">{ip}</td>
                                        <td className="colMeta">
                                            <Popover
                                                title={<code>{event_key}</code>}
                                                content={
                                                    <ObjectInspector
                                                        depth={0}
                                                        path="root.value"
                                                        data={event_meta !== undefined ? (Object.keys(event_meta).length === 0 ? '--' : event_meta) : '--'}
                                                    />
                                                }
                                                placement='rightBottom'
                                                overlayClassName="event-key-popover"
                                                overlayStyle={{ width: '500px !important' }}
                                                trigger="click"
                                            >
                                                <span id={`mypopover_${index}_${_id}`} color="link" className='cursor-pointer'>
                                                    <code>{event_key}</code>
                                                </span>
                                            </Popover>
                                        </td>
                                        <td className="colNote">{note}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                <Pagination
                    pageSizeOptions={['10', '50', '100', '200', '500']}
                    onChange={this._handlePageChange}
                    className='text-right'
                    pageSize={limit}
                    showSizeChanger
                    current={page}
                    total={total}
                />
            </div>
        )
    }
}

ItemHistories.propTypes = {
    item: PropTypes.object.isRequired,
}

export default ItemHistories
